import React from 'react';
import { Helmet } from 'react-helmet';
import useColors from '../../../../hooks/useColors';
import useStyles from '../../../../hooks/useStyles';
import { generateCssVariables } from '../../../../utils/generateCssVariables';

const CssVariables = () => {
  const { colors } = useColors();
  const { styles } = useStyles();
  const cssVarStr = generateCssVariables(colors, styles);
  return (
    <Helmet>
      <style type="text/css">
        {cssVarStr}
      </style>
    </Helmet>
  );
};

export default CssVariables;
